import { Transform, Type } from 'class-transformer';
import {
  IsBoolean,
  IsDateString,
  IsNotEmpty,
  IsNumber,
  IsObject,
  IsOptional,
  Max,
  MaxLength,
  Min,
  ValidateIf,
  ValidateNested,
} from 'class-validator';
import { AccountAddressDto } from '../account-addresses/account-address.dto';
import { sanitizeString } from '../utils';
import { CasePickupContactDto } from './case-pickup-contact.dto';
import { PackageDimensions } from './package-dimensions.dto';

export class CasePickupValidateDto {
  /**
   * Contact details of the personnel who's responsible for arranging the pickup at the dealer/retailer
   */
  @ValidateNested({ always: true })
  @IsObject()
  @Type(() => CasePickupContactDto)
  contact: CasePickupContactDto;

  /**
   * Address of the pickup location (dealer/retailer)
   */
  @IsOptional()
  @ValidateIf((body) => body?.address)
  @IsObject()
  @ValidateNested()
  @Type(() => AccountAddressDto)
  address?: AccountAddressDto;

  /**
   * More information about the the pickup address
   */
  @IsOptional()
  @MaxLength(1000)
  @Transform(({ value }) => sanitizeString(value))
  addressNotes?: string;

  /**
   * Customer refrence
   */
  @IsOptional()
  @MaxLength(255)
  @Transform(({ value }) => sanitizeString(value))
  customerReference?: string;

  /**
   * Is the access to the pickup location restricted in any way? (Access cards / Gates etc.)
   */
  @IsBoolean()
  restrictedAccess: boolean;

  /**
   * Is tail lift required for pickup?
   */
  @IsBoolean()
  tailLiftRequired: boolean;

  /**
   * Preferred pickup date by the customer/retailer
   */
  @IsDateString()
  pickupDate: Date;

  /**
   * Total weight of the return items
   */
  @IsNumber()
  @Min(0)
  @Max(100_000)
  totalPackageWeight: number;

  /**
   * Weight of an individual pellet/parcel
   */
  @IsNumber()
  @Min(0)
  @Max(100_000)
  singlePackageWeight: number;

  /**
   * Unit of weight for the parcel and/or pellet
   */
  @IsNotEmpty()
  @MaxLength(10)
  weightUnit: string;

  /**
   * Dimensions of a single parcel and/or pellet
   */
  @IsObject()
  @ValidateNested()
  @Type(() => PackageDimensions)
  dimensions: PackageDimensions;
}
